import { render, staticRenderFns } from "./CouponBase.vue?vue&type=template&id=72e25ea9&"
import script from "./CouponBase.vue?vue&type=script&lang=js&"
export * from "./CouponBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports